import axios from "axios";

interface IUploadBookingAttachmentParams {
    bookingId: string,
    file: File | null,
    type: string
}

export const uploadBookingAttachment = async ({ bookingId, ...params }: IUploadBookingAttachmentParams): Promise<void> => {
    const response = await axios.post(`/booking/${bookingId}/addAttachment`,
        params,
        {
            params: {type: params.type},
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    return response.data;
};

export default uploadBookingAttachment;
